export default __webpack_public_path__ + "static/media/ardennes.0db15c51.jpg";